export interface StatData {
  value: number;
  suffix: string;
  label: string;
}

export const stats: StatData[] = [
  {
    value: 40,
    suffix: '+',
    label: 'Visionary Speakers'
  },
  {
    value: 2000,
    suffix: '+',
    label: 'Attendees'
  },
  {
    value: 20,
    suffix: '+',
    label: 'Sponsors'
  }
];
